import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '../../lib/firebase/config';
import { Package } from '../../types/package';

export const setupPackagesListener = (
  onUpdate: (packages: Record<string, Package>) => void,
  onError: (error: Error) => void
) => {
  return onSnapshot(
    collection(firestore, 'Packages'),
    (snapshot) => {
      const packages: Record<string, Package> = {};
      snapshot.forEach((doc) => {
        packages[doc.id] = {
          ...doc.data(),
          id: doc.id
        } as Package;
      });
      onUpdate(packages);
    },
    (error) => {
      console.error('Error in packages listener:', error);
      onError(error);
    }
  );
};